export const SERVICE_TYPES = ["AB_TEST", "FEATURE_FLAG", "REMOTE_CONFIG", "IN_APP_MESSAGE"] as const

export type ServiceType = typeof SERVICE_TYPES[number]
